/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon24Solid = forwardRef('ArrowDRadiusDownRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5 4.5a7.5 7.5 0 0 0 7.5 7.5h5.729l-4.04-4.04a1.5 1.5 0 1 1 2.122-2.12l5.185 5.185a3.5 3.5 0 0 1 0 4.95l-5.185 5.186a1.5 1.5 0 0 1-2.122-2.122L18.23 15H12.5C6.701 15 2 10.299 2 4.5v-1a1.5 1.5 0 1 1 3 0v1Z" })));
});
